export const SLICE_NAME = 'book';

export const FETCH_WORDS_FAILURE = `${SLICE_NAME}/FETCH_WORDS_FAILURE`;
export const FETCH_WORDS_SUCCESS = `${SLICE_NAME}/FETCH_WORDS_SUCCESS`;
export const UPDATE_CURRENT_GROUP = `${SLICE_NAME}/UPDATE_CURRENT_GROUP`;
export const UPDATE_CURRENT_PAGE = `${SLICE_NAME}/UPDATE_CURRENT_PAGE`;
export const SHOW_LOADER = `${SLICE_NAME}/SHOW_LOADER`;
export const HIDE_LOADER = `${SLICE_NAME}/HIDE_LOADER`;
export const FETCH_AGGREGATED_WORDS_SUCCESS = `${SLICE_NAME}/FETCH_AGGREGATED_WORDS_SUCCESS`;
export const FETCH_AGGREGATED_WORDS_FAILURE = `${SLICE_NAME}/FETCH_AGGREGATED_WORDS_FAILURE`;
export const FETCH_GAME_WORDS_SUCCESS = `${SLICE_NAME}/FETCH_GAME_WORDS_SUCCESS`;
export const FETCH_GAME_WORDS_FAILURE = `${SLICE_NAME}/FETCH_GAME_WORDS_FAILURE`;
export const UPDATE_IS_TRANSLATION_ON = `${SLICE_NAME}/UPDATE_IS_TRANSLATION_ON`;
export const UPDATE_IS_EDIT_DICTIONARY_BUTTONS = `${SLICE_NAME}/UPDATE_IS_EDIT_DICTIONARY_BUTTONS`;
export const UPDATE_REMOVED_PAGES_FOR_GROUP = `${SLICE_NAME}/UPDATE_REMOVED_PAGES_FOR_GROUP`;
export const UPDATE_REMOVED_PAGES = `${SLICE_NAME}/UPDATE_REMOVED_PAGES`;
export const UPDATE_REMOVED_WORDS_COUNT_FOR_PAGE = `${SLICE_NAME}/UPDATE_REMOVED_WORDS_COUNT_FOR_PAGE`;
export const UPDATE_REMOVED_WORDS_COUNT = `${SLICE_NAME}/UPDATE_REMOVED_WORDS_COUNT`;
export const CLEAR_AGGREGATED_WORDS = `${SLICE_NAME}/CLEAR_AGGREGATED_WORDS`;
